import React, { FC } from 'react'
import { GridIE, FormIE } from 'Pages/interfaceElement'

export const ListIE: FC = () => {
	return (
		<div>
			<FormIE />
			<GridIE />
		</div>
	)
}
